import { render, staticRenderFns } from "./CdlSaude.vue?vue&type=template&id=ac2232e2&"
import script from "./CdlSaude.vue?vue&type=script&lang=js&"
export * from "./CdlSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports